import React, { useEffect, useState } from 'react'
import Sidebar from '../../components/Admin/Sidebar'
import * as Icon from 'react-bootstrap-icons'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const AllCategories = () => {
    const [toggleValue, setToggleValue] = useState(false)
    const [show, setShow] = useState(false)

    const [category, setCategory] = useState('')

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Authentication
    const authtoken = localStorage.getItem('token');
    const token = `Bearer ${authtoken}`;

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {

                const category = await getCategories();
                setCategories(category.categories);

            } catch (error) {
                console.error('Failed to fetch categories:', error);
            }
        };

        fetchCategories(); // Call the async function
    }, []); // Empty dependency array to only run once on mount

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (category === '') {
            toast.error("Please add a category!");
            return;
        }

        try {

            const response = await axios.post(`${process.env.REACT_APP_API_URL}product/categories/add`, { "name": category }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            });
            const message = response.data.message;
            const status = response.data.status;

            if (status === "error") {
                toast.warn(message);
            } else {
                toast.success("Category successfully uploaded");
                setCategory('')
                const category = await getCategories();
                setCategories(category.categories);
            }

        } catch (error) {
            toast.error('Error:', error);
        }
    }

    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 p-0'>
                        <Sidebar toggleSidebar={toggleValue} setToggleValue={setToggleValue} />
                    </div>
                    <div className='col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper'>
                        <Icon.ArrowRight onClick={() => setToggleValue(true)} className='my-5 sidebar-open' color='black' size={30}></Icon.ArrowRight>
                        <div className='row dashboard-content mt-lg-0 mt-md-3 mt-3'>
                            {/* <div className="col-12">
                                <h5>Categories</h5>
                                {
                                    categories.length > 0
                                        ?
                                        <h6 className='text-muted'>View & add categories</h6>
                                        :
                                        <h6 className='text-muted'>No categories added</h6>

                                }
                            </div> */}
                            <div className='col-12 my-0'>
                                <div className='row'>
                                    <div className='col-lg-10 col-md-8 col-6'>
                                        {/* <Button variant="success" onClick={handleShow}>Add category<Icon.PlusCircle className='ms-2' /></Button> */}
                                        <h5>Categories</h5>
                                        {
                                            categories.length > 0
                                                ?
                                                <h6 className='text-muted'>View & add categories</h6>
                                                :
                                                <h6 className='text-muted'>No categories added</h6>

                                        }
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-6'>
                                        {/* <Form.Control
                                            type="text"
                                            placeholder="Search products"
                                            className=" mr-sm-2 shadow-none"
                                        /> */}
                                        <Button variant="success" onClick={handleShow}>Add category<Icon.PlusCircle className='ms-2' /></Button>

                                    </div>

                                </div>
                                <div className='mt-5'>
                                    <div className="row">
                                        {categories.map((category) => (
                                            <div key={category.id} className="col-lg-2 col-md-4 col-6 mb-lg-3 mb-md-3 mb-3">
                                                <div className='card p-3 shadow w-100'>
                                                    {category.name}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add category modal */}
            <Modal show={show} onHide={handleClose} size="lg">
                <form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title><Icon.Tag color='black' size={40} /></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className='col-12'>
                                <FloatingLabel controlId="floatingInput" label="Category" className="mb-3">
                                    <Form.Control
                                        type="text"
                                        className='shadow-none'
                                        placeholder="Category"
                                        value={category}
                                        onChange={(e) => setCategory(e.target.value)}
                                    />
                                </FloatingLabel>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className=''>
                        <Button variant="success" type="submit" className='shadow-none' onClick={handleClose}>
                            Add category
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <ToastContainer theme="dark" autoClose={2000} />
        </>
    )
}

export default AllCategories

export const getCategories = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}product/categories`);
        return response.data;
    } catch (error) {
        console.error('Error:', error);
    }
};